import { useParams } from 'react-router-dom';

import { RewardsQaContent } from '@components';

import './style.scss';

export function RewardsQaPage() {
  const { accountUsername } = useParams<{ accountUsername: string }>();

  return (
    <div className="rewards-qa-page">
      <div className="rewards-qa-page__main">
        <RewardsQaContent accountName={accountUsername} />
      </div>
    </div>
  );
}
